import { render, staticRenderFns } from "./CloudResource.vue?vue&type=template&id=0351ae9d&scoped=true&"
import script from "./CloudResource.vue?vue&type=script&lang=js&"
export * from "./CloudResource.vue?vue&type=script&lang=js&"
import style0 from "./CloudResource.vue?vue&type=style&index=0&id=0351ae9d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0351ae9d",
  null
  
)

export default component.exports